export default __webpack_public_path__ + "static/media/Listify.90f42b7c.png";